import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { InfoIcon } from '../Objects/Icons/FeatherIcons';
import { Typography } from '@mui/material';

const StyledTooltip = styled(({ className, ...props }) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 207,
    background: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: 1.66667,
    letterSpacing: '0.4px',
    border: 0,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
});

const defaultIcon = <InfoIcon color='white' />;

function Tooltip({ placement = 'top', title, icon = defaultIcon, ...rest }) {
  return (
    <StyledTooltip arrow placement={placement} title={title} {...rest}>
      {icon ? (
        <IconButton sx={{ p: 0, m: 0 }}>
          <InfoIcon color='white' />
        </IconButton>
      ) : (
        <Typography variant='p'> Phone not provided </Typography>
      )}
    </StyledTooltip>
  );
}

Tooltip.propTypes = {
  placement: PropTypes.string,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
};

export default Tooltip;
